/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-named-as-default */
// eslint-disable-next-line import/no-named-as-default-member
import { ApiPrefixV1, ApiV1Base, ApiPrefix } from 'util/icwUtility';
import qs from 'qs';
import Request from './request';

export const apiGetSupplierFiles = async (id, params = {}) => {
  const queryString = qs.stringify(params, {
    encodeValuesOnly: false,
    indices: false,
  });
  return Request.call({
    url: `/micro/suppliers/${id}/documents?${queryString}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiCreateSupplierFolder = async (id, data) => {
  return Request.call({
    url: `/micro/suppliers/${id}/folder`,
    method: 'POST',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiDeleteSupplierFiles = async (id, data) => {
  return Request.call({
    url: `/micro/suppliers/${id}/documents`,
    method: 'DELETE',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiSupplierUploadFileToFolder = async (id, data) => {
  return Request.call({
    url: `/micro/suppliers/${id}/documents`,
    method: 'POST',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiSupplierMoveFileFolderV2 = async (id, data) => {
  return Request.call({
    url: `/micro/suppliers/${id}/documents`,
    method: 'PATCH',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiCreateSharedSupplierDocumentToken = async (id, data) => {
  return Request.call({
    url: `/micro/suppliers/${id}/documents/shared`,
    method: 'POST',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiRenameSupplierFolder = async (id, folderId, data) => {
  return Request.call({
    url: `/micro/suppliers/${id}/folder/${folderId}`,
    method: 'PATCH',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiVerifySupplierFiles = async (supplierId, fileId, data = {}) => {
  return Request.call({
    url: `supplier/${supplierId}/documents/${fileId}/verified`,
    data,
    method: 'PUT',
    apiPrefix: `${ApiV1Base}${ApiPrefix}`,
  });
};
export const apiDuplicateSupplier = async (supplierId) => {
  return Request.call({
    url: `/micro/suppliers/${supplierId}/duplicate`,
    data: {},
    method: 'POST',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
